import { render, staticRenderFns } from "./DragFileView.vue?vue&type=template&id=30834bec&scoped=true&"
import script from "./DragFileView.vue?vue&type=script&lang=js&"
export * from "./DragFileView.vue?vue&type=script&lang=js&"
import style0 from "./DragFileView.vue?vue&type=style&index=0&id=30834bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30834bec",
  null
  
)

export default component.exports